var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flexCen"},[_c('img',{attrs:{"src":require("@/assets/images/common/error-404.jpg"),"alt":""}}),_c('router-link',{attrs:{"to":"/index"}},[_c('el-button',{staticClass:"goback"},[_vm._v("返回首页")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }